import { Platform } from 'react-native';
import styled from 'styled-components/native';

import Avatar from 'components/Avatar';

export default styled(Avatar)`
  margin-bottom: ${Platform.OS === 'web' ? 0 : -26}px;
  margin-right: 15px;
`;
